import React from 'react'

const NotFound = () => (<div><h2>You have fallen off the edge of this website</h2></div>)

export default NotFound